module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-card', {
    staticClass: "max-auto",
    attrs: {
      "min": ""
    }
  }, [_c('v-card-title', [_c('h4', [_vm._v("Agregar Extracción")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tipoextracciones,
      "item-text": "tipo",
      "item-value": "id",
      "label": "Tipo Extraccion"
    },
    model: {
      value: (_vm.tipoextraccion),
      callback: function($$v) {
        _vm.tipoextraccion = $$v
      },
      expression: "tipoextraccion"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "ml-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cantidad"
    },
    model: {
      value: (_vm.cantidad),
      callback: function($$v) {
        _vm.cantidad = $$v
      },
      expression: "cantidad"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-3": ""
    }
  }, [_c('v-btn', {
    staticClass: "print blue darken-4",
    attrs: {
      "dark": ""
    },
    on: {
      "click": _vm.guardarextraccion
    }
  }, [_vm._v("\n            Guardar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e6c384"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/extraccionadd.vue
// module id = 436
// module chunks = 1